import React from 'react';

export default function Button({ label, variant = 'primary', icon, onClick ,disabled}) {
  // variant: 'primary', 'danger', 'success', 'outline', etc.
  const btnClass = `btn btn-${variant} d-flex align-items-center`;
  return (
    <button className={btnClass} onClick={onClick} disabled={disabled}>
      {icon && <span className="me-1">{icon}</span>}
      {label}
    </button>
  );
}